module.exports = __webpack_public_path__ + "static/img/QRcode.104c541.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/QRcode.jpg
// module id = NhIN
// module chunks = 6